module.exports = __webpack_public_path__ + "store-availability-in-stock/store-availability-in-stock-ffe883970c754bd636e69cfc8576a383.svg";